/** Operational status of an asset / gateway / connection. */
export const STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  WARNING: 'warning',
  ERROR: 'error',
  IDLE: 'idle',
  UNKNOWN: 'unknown',
} as const

export type Status = (typeof STATUS)[keyof typeof STATUS]

/** Data quality of a tag reading (OPC-UA style). */
export const QUALITY = {
  GOOD: 'good',
  BAD: 'bad',
  UNCERTAIN: 'uncertain',
} as const

export type Quality = (typeof QUALITY)[keyof typeof QUALITY]

/** Alarm severity, ordered most → least critical (see SEVERITY_WEIGHT in utils). */
export const SEVERITY = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  INFO: 'info',
} as const

export type Severity = (typeof SEVERITY)[keyof typeof SEVERITY]
